import { useMemo } from "react";

const COLOR = {
  off: '#416cd6',
  on: '#fff',
  disabled: '#444',
}

type Props = {
  theme?: keyof typeof COLOR;
  size?: number;
};


export const ImageIcon = ({ theme = 'off', size = 22 }: Props) => {
  const color = useMemo(() => COLOR[theme], [theme]);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.39 15.65" width={size} height={size}>
      <g id="レイヤー_2" data-name="レイヤー 2">
        <g id="レイヤー_1-2" data-name="レイヤー 1">
          <circle fill={color} cx="4.76" cy="4.76" r="1.3" />
          <polygon
            fill={color}
            points="9.08 8.66 6.93 6.96 3.46 12.13 10.55 12.13 9.89 11.47 13.21 8.15 11.26 5.2 9.08 8.66"
          />
          <polygon
            fill={color}
            points="1.73 13.86 1.73 1.73 17.32 1.73 17.32 9.97 19.05 8.23 19.05 0 0 0 0 15.59 14.02 15.59 12.29 13.86 1.73 13.86"
          />
          <polygon
            fill={color}
            points="21.17 8.6 16.56 13.21 15.48 12.13 13.59 10.24 12.37 11.46 13.03 12.13 16.56 15.65 22.39 9.82 21.17 8.6"
          />
        </g>
      </g>
    </svg>
  );
  };
